import React from "react"
import avatar from "avatar/zen.svg"

const Zen = (props) => <img src={avatar} className="avatar" {...props} />

export default Zen
